'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _util = require('util');

var _util2 = _interopRequireDefault(_util);

var _identifyAction = require('./identifyAction');

var _identifyAction2 = _interopRequireDefault(_identifyAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var repeatedActionError = function repeatedActionError(repeatedActionBodies) {
  return new Error(['Rendering has been aborted to prevent an infinite loop. ', 'The following asynchronous actions were called repeatedly in ', 'successive rendering cycles: '].concat(_toConsumableArray(repeatedActionBodies.map(function (action) {
    if (typeof action === 'function') {
      return action.toString();
    }

    return _util2.default.inspect(action, {
      depth: 2
    });
  }))).join(''));
};

/**
 * Creates a universal render function.
 *
 * By interacting with the passed promise watcher and the store it ensures that
 * the rendering reiteratively continues until no further actions are dispatched
 * and all current promises are resolved.
 *
 * The inner workings of the repetitive rendering require that each watched
 * promise also dispatches an action when it is resolved or rejected. Using it
 * together with a middleware that handles promises from synchronous action
 * creators is encouraged.
 */

exports.default = function (getPromises) {
  return function (renderFn, element) {
    return new Promise(function (resolve, reject) {
      var seenPromises = [];
      var seenActions = {};
      var output = '';

      var render = function render(promiseError) {
        try {
          // Invoke the actual render function (e.g. ReactDOM.renderToString).
          if (promiseError) {
            throw promiseError;
          }
          output = renderFn(element);
          var activePromises = getPromises();

          var _activePromises$filte = activePromises.filter(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 1),
                promise = _ref2[0];

            return seenPromises.indexOf(promise) === -1;
          }).reduce(function (_ref3, _ref4) {
            var _ref6 = _slicedToArray(_ref3, 2),
                promiseA = _ref6[0],
                actionA = _ref6[1];

            var _ref5 = _slicedToArray(_ref4, 2),
                promiseB = _ref5[0],
                actionB = _ref5[1];

            return [promiseA.concat(promiseB), actionA.concat(actionB)];
          }, [[], []]),
              _activePromises$filte2 = _slicedToArray(_activePromises$filte, 2),
              newPromises = _activePromises$filte2[0],
              newActions = _activePromises$filte2[1];

          var actionsWithoutDuplicates = newActions.reduce(function (map, action) {
            return _extends({}, map, _defineProperty({}, (0, _identifyAction2.default)(action), action));
          }, {});

          var repeatedActionBodies = Object.keys(actionsWithoutDuplicates).filter(function (key) {
            return Object.prototype.hasOwnProperty.call(seenActions, key);
          }).map(function (key) {
            return actionsWithoutDuplicates[key];
          });

          if (repeatedActionBodies.length) {
            throw repeatedActionError(repeatedActionBodies);
          } else {
            seenPromises = seenPromises.concat(newPromises);
            seenActions = _extends({}, seenActions, actionsWithoutDuplicates);

            if (!activePromises.length) {
              resolve({ output: output });
            } else {
              // If any promises are left, re-render once they have
              // finished or the first promise rejects
              Promise.all(activePromises.map(function (_ref7) {
                var _ref8 = _slicedToArray(_ref7, 1),
                    promise = _ref8[0];

                return promise;
              })).then(function () {
                return render();
              }, render);
            }
          }
        } catch (error) {
          reject({ output: output, error: error });
        }
      };

      render();
    });
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/@bd/redux-universal/lib/createRenderer.js
// module id = 1178
// module chunks = 0